var externalFileAirlines = [
  "Air Canada (AC)",
  "Air France (AF)",
  "Air India (AI)",
  "Aeromexico (AM)",
  "Air One (AP)",
  "Aloha Airlines (AQ)",
  "Alaska Airlines (AS)",
  "Avianca (AV)",
  "Binter Mediterra (AX)",
  "Finnair (AY)",
  "Alitalia (AZ)",
  "British Airways (BA)",
  "bmi british (BD)",
  "British European (BE)",
  "EVA Airways (BR)",
  "BWA Caribbean Air (BW)",
  "Air China (CA)",
  "China Airlines (CI)",
  "Copa Airlines (CM)",
  "Continental (CO)",
  "Cathay Pacific (CX)",
  "China Southern (CZ)",
  "Delta (DL)",
  "Japan Asia (EG)",
  "Aer Lingus (EI)",
  "Emirates Airlines (EK)",
  "Icelandair (FI)",
  "Air Pacific (FJ)",
  "Gulf Air (GF)",
  "Hawaiian (HA)",
  "America West (HP)",
  "Iberia (IB)",
  "KFR Kingfisher Ai (IT)",
  "JAL Express (JC)",
  "Latam Airlines Brasil (JJ)",
  "Japan Airlines (JL)",
  "Air Jamaica (JM)",
  "JALways (JO)",
  "Dragonair Hong (KA)",
  "Korean Air (KE)",
  "KLM (KL)",
  "Kuwait Airways (KU)",
  "Philippine (PR)",
  "LATAM Airlines (LA)",
  "Lufthansa (LH)",
  "LOT Polish (LO)",
  "LATAM Airlines Peru (LP)",
  "Lacsa (LR)",
  "SWISS (LX)",
  "El Al Israel (LY)",
  "Malev Hungarian (MA)",
  "Middle East (ME)",
  "Malaysia (MH)",
  "China Eastern (MU)",
  "Mexicana (MX)",
  "All Nippon (NH)",
  "Japan Transocean (NU)",
  "Northwest (NW)",
  "Air New Zealand (NZ)",
  "Olympic Airways (OA)",
  "Austrian Air (OS)",
  "Executive Air (OW)",
  "Asiana Airlines (OZ)",
  "TAM del Mercosur (PZ)",
  "Qantas Airways (QF)",
  "Qatar Airways (QR)",
  "Royal Jordanian (RJ)",
  "South African (SA)",
  "SAS (SK)",
  "SN Brussels Airl (SN)",
  "Singapore Airl (SQ)",
  "Saudi Arabian (SV)",
  "Taca Intl (TA)",
  "Thai Intl (TG)",
  "Air Tahiti Nui (TN)",
  "Tap Portugal (TP)",
  "American Trans (TZ)",
  "United (UA)",
  "SriLankan (UL)",
  "Bahamasair (UP)",
  "US Airways (US)",
  "Vietnam Air (VN)",
  "Virgin Atlantic (VS)",
  "Viva Air Perú (VV)",
  "LanEcuador (XL)",
  "Mesa Airlines (YV)",
  "Midwest Express (YX)",
  "Lan Argentina (4M)",
  "ERA Aviation (7H)",
  "Cape Air (9K)",
  "Jet Airways (9W)",
  "American (AA)",
  "Biman Bangladesh (BG)",
  "Ethiopian Air (ET)",
  "Shanghai (FM)",
  "Iran Air (IR)",
  "Spanair (JK)",
  "Adria Airways (JP)",
  "Bearskin Airline (JV)",
  "Air Botnia (KF)",
  "Kenya Airways (KQ)",
  "Cayman Airways (KX)",
  "Air Mauritius (MK)",
  "Czech Airlines (OK)",
  "Croatia Airlines (OU)",
  "Aeroflot (SU)",
  "Turkish Airlines (TK)",
  "Wideroes Flyvese (WF)",
  "Canadian North (5T)",
  "First Air (7F)",
  "Central Mtn Air (9M)",
  "Royal Air Maroc (AT)",
  "ScotAirways (CB)",
  "Siem Reap (FT)",
  "Air Seychelles (HM)",
  "Indian Airlines (IC)",
  "Luxair (LG)",
  "Air Madagascar (MD)",
  "SilkAir (MI)",
  "Portugalia (NI)",
  "Bangkok Airways (PG)",
  "CDI Air Caledoni  (SB)",
  "Tunis Air (TU)",
  "Air Caraibes (TX)",
  "Twin Jet (T7)",
  "Air Austral (UU)",
  "Air Europa (UX)",
  "Air Senegal (V7)",
  "Windward Island (WM)",
  "Compagnie Corse (XK)",
  "Aerolineas Argentinas (AR)",
  "Hahn Air (HR)",
  "AEROLINEAS DEL SUR (3I)",
  "Air Algerie (AH)",
  "Aegean Air (A3)",
  "Air Botswana (BP)",
  "Cyprus Airways (CY)",
  "Etihad Airway (EY)",
  "Viva Air (FC)",
  "Meridiana (IG)",
  "JAT (JU)",
  "Air Malta (KM)",
  "Egyptair (MS)",
  "Precisionair (PW)",
  "Tarom-Romanian (RO)",
  "Siberia Airlines (S7)",
  "VLM Airlines (VG)",
  "Oman Aviation (WY)",
  "Martinair Hollan (MP)",
  "Wingo (P5)",
  "Frontier (F9)",
  "GHANA INTL AIRLINES  (G0)",
  "Ukraine Intl (PS)",
  "Eurasia Airlines (UH)",
  "Virgin Exp Irela (VK)",
  "Aeromar (VW)",
  "Island Air Hawai (WP)",
  "Great Lakes (ZK)",
  "Air Berlin (AB)",
  "Nationwide Air (CE)",
  "Deutsche BA (DI)",
  "LZB Bulgaria Air (FB)",
  "Aviateca (GU)",
  "Azerbaijan Airl (J2)",
  "Air Namibia (SW)",
  "Air Moldova (9U)",
  "Calafia Airlines (A7)",
  "Rossiya (FV)",
  "SKY Airline (H2)",
  "AIR ASTANA (KC)",
  "OGE Atiasjet Intl (KK)",
  "LTU Intl (LT)",
  "Air Vanuatu (NF)",
  "Plus Ultra (PU)",
  "Surinam Airways (PY)",
  "TACV Cabo Verde (VR)",
  "Carpatair (V3)",
  "Lithuanian (TE)",
  "Air Tahiti (VT)",
  "Cirrus Airlines (C9)",
  "Air Dolomiti (EN)",
  "Mandarin (AE)",
  "Air Baltic (BT)",
  "MONTENEGRO AIRLINES (YM)",
  "Air Nippon (EL)",
  "Xiamen Airlines (MF)",
  "Air Macau (NX)",
  "Varig (RG)",
  "Vladivostok Air (XF)",
  "Macair (CC)",
  "Sunshine Express (CQ)",
  "Air Link (DR)",
  "BRINDABELLA AIRLINES (FQ)",
  "Solomon (IE)",
  "AEROPELICAN (OT)",
  "Air Niugini (PX)",
  "Air North Region (TL)",
  "O Connor Air (UQ)",
  "Hazelton (ZL)",
  "LAM (TM)",
  "Air Zimbabwe (UM)",
  "Island Air Nantk (IS)",
  "Yemenia Yemen (IY)",
  "Gulfstream Intl (3M)",
  "Test (ZZ)",
  "ZUZA (ZA)",
  "AIWA (AW)",
  "Clic (EF)",
  "veintitres (23)",
  "Jetblue airways (B6)",
  "Airtran airways (FL)",
  "Gol (G3)",
  "Volaris (VO)",
  "Santa Barbara (S3)",
  "AeroGal (2K)",
  "Conviasa (V0)",
  "Insel Air (7I)",
  "WestJet (WS)",
  "Southwest  (WN)",
  "Aserca Airlines (R7)",
  "Tame (EQ)",
  "NORWEGIAN AIR SHUTTLE (DY)",
  "Shuttle America (S5)",
  "Dutch Antilles Express (9H)",
  "Tiara Air (3P)",
  "Vueling Airlines (VY)",
  "Spirit Airlines (NK)",
  "Austral Lineas Aéreas (AU)",
  "Germanwings (4U)",
  "Niki (HG)",
  "Transavia Airlines (HV)",
  " Iberia Express (I2)",
  "Alitalia CityLiner (CT)",
  "Air Nostrum (YW)",
  "Porter Airlines (PD)",
  "CityJet (WX)",
  "Lufthansa CityLine (CL)",
  "Eurowings (EW)",
  "SATA International (S4)",
  "SATA - Air Acores (SP)",
  "Sun Country Airlines (SY)",
  "Virgin America (VX)",
  "Condor (DE)",
  "EasyFly (VE)",
  "J-Air (XM)",
  "Amaszonas S.A (Z8)",
  "Aerocomercial Oriente Norte (A4)",
  "Edelweiss Air (WK)",
  "Air Busan (BX)",
  "Jetstar Japan (GK)",
  "Garuda Indonesia (GA)",
  "Air Transat (TS)",
  "Blue Panorama Airlines (BV)",
  "FlexFlight (W2)",
  "TUI Airlines Nederland (OR)",
  "Aer Arann Express (RE)",
  "Andes Lineas Aereas (OY)",
  "Sunwing Airlines (WG)",
  "Cubana de Aviacion (CU)",
  "Myway Airlines (8I)",
  "Hainan Airlines (HU)",
  "Shenzhen Airlines (ZH)",
  "Avior Airlines (9V)",
  "Volaris (Y4)",
  "Interjet (4O)",
  "Taca Peru (T0)",
  "Transavia France (TO)",
  "Heli Air Monaco (YO)",
  "Star Peru (2I)",
  "Peruvian Airlines (P9)",
  "LATAM Airlines Colombia (4C)",
  "Azul Brazilian Airlines (AD)",
  "Accesrail (9B)",
  "LC Peru (W4)",
  "FINNISH COMMUTER AIR (VC)",
  "Viva Aerobus (VB)",
  "Conocemos Navegando (0C)",
  "Smartwings Airlines (QS)",
  "Avianca Brasil (O6)",
  "Avianca Argentina (A0)",
  "Boliviana de Aviación (OB)",
  "TAAG (DT)",
  "Belavia (B2)",
  "Satena (9R)",
  "Hahn Air System (H1)",
  "Speed Alliance Westbahn (5W)",
  "Rusline (7R)",
  "Utair Aviation (UT)",
  "Ural Airlines (U6)",
  "Red Wings Airlines (WZ)",
  "Yamal Airlines (YC)",
  "Viva (VH)",
  "Air Panamá (7P)",
  "Agp Airlines (GP)",
  "Plus Ultra Premium (Z0)",
  "Plus Ultra Business (Q1)",
  "Amaszonas Uruguay (Z7)",
  "Passaredo Linhas Aéreas (2Z)",
  "Flybondi (FO)",
  "Volaris (Q6)",
  "GCA (9A)",
  "TAR Airlines (YQ)",
  "Paranair (ZP)",
  "TAG Airlines (5U)",
  "JetSmart (JA)",
  "JetSmart (JZ)",
  "JetSmart (WJ)",
  "Sky Airline (H8)"
];
